export const getTrackerMeta = (trackerCount: number, trackerLimit: number) => {
  const remaining = trackerLimit - trackerCount;
  const isAtLimit = remaining <= 0;
  return { remaining, isAtLimit };
};
